// Icons for the dashboard
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

export const ErrorAlertRedIcon = () => <img src="/timeline/rocket-orange-icon-transparent.png" alt="Required" />;
export const ErrorAlertWhiteIcon = () => <img src="/timeline/alert-white-transparent.png" alt="Required" />;

export const RocketIcon = () => <img src="/timeline/rocket_icon_transparent.png" alt="Start Day" />;

export const BookIcon = () => <img src="/timeline/book_icon_transparent.png" alt="Started books" />;

export const DocumentIcon = () => <img src="/timeline/checklist_icon_transparent.png" alt="Responses" />;

export const ShoppingBagIcon = () => <img src="/timeline/bag_icon_transparent.png" alt="Orders" />;

export const EditIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <img src="/controls/edit_icon_transparent.png" alt="Orders" className={className} />
);

export const InfoIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <FontAwesomeIcon title="About timeline" icon={faInfo} className={className} />
);

// Timeline step icons
export const EnvelopeIcon = () => <img src="/timeline/mail-grey-transparent.png" alt="Mail" />;
// Timeline step icons
export const EnvelopeIconDone = () => <img src="/timeline/mail-white-transparent.png" alt="Mail" />;

export const PersonIcon = () => <img src="/timeline/student-grey-transparent.png" alt="Student" />;

export const PersonIconDone = () => <img src="/timeline/student-white-transparent.png" alt="Student" />;

export const DocumentArrowIcon = () => <img src="/timeline/books-grey-transparent.png" alt="Flyers" />;

export const DocumentArrowIconDone = () => <img src="/timeline/books-white-transparent.png" alt="Flyers" />;

export const PrinterIcon = () => <img src="/timeline/print-grey-transparent.png" alt="Print" />;

export const PrinterIconDone = () => <img src="/timeline/print-white-transparent.png" alt="Print" />;

export const RocketTimelineIcon = () => <img src="/timeline/rocket-grey-transparent.png" alt="Start" />;
export const RocketTimelineIconDone = () => <img src="/timeline/rocket-white-transparent.png" alt="Start" />;

export const CircularArrowIcon = () => <img src="/timeline/student-signin-grey-transparent.png" alt="Login" />;
export const CircularArrowIconDone = () => <img src="/timeline/student-signin-white-transparent.png" alt="Login" />;

export const HourglassIcon = () => <img src="/timeline/time-grey-transparent.png" alt="Deadline" />;

export const HourglassIconDone = () => <img src="/timeline/time-white-transparent.png" alt="Deadline" />;

export const BoxIcon = () => <img src="/timeline/ship-grey-transparent.png" alt="Ship" />;

export const BoxIconDone = () => <img src="/timeline/ship-white-transparent.png" alt="Ship" />;

export const ConfettiIcon = () => <img src="/timeline/congrats-grey-transparent.png" alt="Congrats" />;

export const ConfettiIconDone = () => <img src="/timeline/congrats-white-transparent.png" alt="Congrats" />;
